import axios from 'axios';
import { history } from '../routers/AppRouter';
import { VENDORS_ENDPOINT } from '../api/api';

export const FETCH_VENDORS_SUCCESS = 'FETCH_VENDORS_SUCCESS';
export const ADD_VENDOR = 'ADD_VENDOR';
export const VENDOR_LOAD_ERROR = 'VENDOR_LOAD_ERROR';
export const VENDOR_LOADING = 'VENDOR_LOADING';
export const EDIT_VENDOR = 'EDIT_VENDOR';

export const vendorLoading = () => {
  return ({
    type: VENDOR_LOADING
  });
}

export const startFetchVendors = () => {
  return async (dispatch) => {
    try {
      const vendors = await axios({
        method: 'get',
        url: `${VENDORS_ENDPOINT}`,
        headers: JSON.parse(sessionStorage.user)
      });
      dispatch(fetchVendorsSuccess(vendors.data));
    } catch (error) {
      console.log(error.message);
    }
  };
};

const fetchVendorsSuccess = (vendors) => ({
  type: FETCH_VENDORS_SUCCESS,
  vendors
});


export const addVendor = (vendor) => {
  console.log(vendor);
  return ({
    type: ADD_VENDOR,
    vendor
  });
};

export const startAddVendor = (vendorData = {}) => {

  return async (dispatch) => {
    try {
      dispatch(vendorLoading());
      let vendor = await axios({
        method: 'post',
        url: VENDORS_ENDPOINT,
        headers: JSON.parse(sessionStorage.user),
        data: vendorData
      });
      return dispatch(addVendor({
        ...vendor.data
      }), history.push('/cashier'));
    } catch (err) {
      console.log(err);
      if (err.response && err.response.status === 422) {
        return dispatch(vendorLoadError({ errMessage: err.response.data.message }));
      }
      return dispatch(vendorLoadError({ errMessage: 'Please check your connection and try again' }));
    }
  };
};


const vendorLoadError = (errMessage) => ({
  type: VENDOR_LOAD_ERROR,
  errMessage
});


export const editVendor = (id, updates) => {
  return ({
    type: EDIT_VENDOR,
    id,
    updates
  });
};

export const startEditVendor = (id, updates) => {
  console.log(id);
  return async (dispatch) => {
    try {
      // const entry = await axios.put(`${ENTRIES_ENDPOINT}/${id}`, updates);
      let vendor = await axios({
        method: 'patch',
        url: `${VENDORS_ENDPOINT}/${id}`,
        headers: JSON.parse(sessionStorage.user),
        data: updates
      });
      console.log(vendor);
      return dispatch(editVendor(vendor.data.id, vendor.data), history.push('/cashier'));
    } catch (err) {
      console.log(err);
      if (err.response && err.response.status === 422) {
        return dispatch(vendorLoadError({ errMessage: err.response.data.message }));
      }
      return dispatch(vendorLoadError({ errMessage: 'Please check your connection and try again' }));
    }
  };
};



// WEBPACK FOOTER //
// ./src/actions/vendorActions.js